import RepositoryFactory from "../../admin/apis/index";
const transaction = RepositoryFactory.transaction;

export default {
  createTransaction({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("createTransaction called");
        const { data } = await transaction.CreateTransaction(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateTransaction({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("updateTransaction called");
        const { data } = await transaction.UpdateTransaction(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getTransaction({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await transaction.GetTransaction(payload);
        commit("SET_TRANSACTION", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
